enum ClaimFiledBy {
	PRODUCER = 'Producer',
	INSURED = 'Insured',
	OTHER = 'Other'
}

export default ClaimFiledBy;